export default __webpack_public_path__ + "static/media/image3.928a5ff8.jpg";